import { useRoute } from '@/hooks/useRoute';
import { InstructorsList } from './InstructorsList';
import { InstructorDetail } from './InstructorDetail';
import { DisassocRequests } from './DisassocRequests';

export function InstructorScreen() {
  const route = useRoute();
  if (route.view === 'disassoc') return <DisassocRequests />;
  if (route.instructorId) return <InstructorDetail instructorId={route.instructorId} />;
  return <InstructorsList />;
}
